import { NgModule } from '@angular/core';
import { BuSectionComponent } from './bu-section/bu-section.component';

@NgModule({
  imports: [],
  declarations: [BuSectionComponent],
  exports: [BuSectionComponent]
})
export class BuSectionModule { }
